import { MMKV } from 'react-native-mmkv';
import { IHeartRate } from 'fitbeat.models';

/**
 * Responsible for persisting the heart rate state, so that we don't loose work when the app is restarted
 */
export class HeartRateTempPersistance {
  private storage = new MMKV({
    id: 'heart-rate-state-storage',
  });

  private logger?: any;

  constructor(logger?: any) {
    this.logger = logger;
  }

  public storeHeartRate(heartRateData: IHeartRate, workoutId: string): void {
    try {
      if (!heartRateData.heartRate || heartRateData.heartRate === 0 || isNaN(heartRateData.heartRate)) {
        return;
      }
      if (!heartRateData.timestamp) {
        return;
      }
      if (!workoutId) {
        return;
      }
      this.storage.set(
        `${workoutId}-${heartRateData.timestamp.getTime().toString()}`,
        heartRateData.heartRate,
      );
    } catch (error) {
      this.logError(error);
    }
  }

  public getStoredHeartRates(workoutId: string): IHeartRate[] {
    try {
      const allKeys = this.storage.getAllKeys();
      return allKeys
        .filter((key: string) => key.startsWith(workoutId))
        .map((key: string) => {
          try {
            const timestampValue = key.split('-')[1];
            const timestampInt = parseInt(timestampValue, 10);
            if (Number.isNaN(timestampInt)) {
              return null;
            }
            const timestamp = new Date(timestampInt);
            if (!timestamp || isNaN(timestamp.getTime())) {
              return null;
            }
            const heartRate = this.storage.getNumber(key);
            if (heartRate == null || Number.isNaN(heartRate)) {
              return null;
            }
            return {
              timestamp,
              heartRate,
            } as IHeartRate;
          } catch (error) {
            this.logError(error);
            return null;
          }
        })
        .filter((item): item is IHeartRate => item !== null)
        .sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());
    } catch (error) {
      this.logError(error);
      return [];
    }
  }

  public deleteAllStoredHeartRates(): void {
    try {
      this.storage.clearAll();
    } catch (error) {
      this.logError(error);
    }
  }

  private logError(error: any): void {
    if (this.logger) {
      this.logger.notify(error);
    }
  }
}
